import { Input } from 'legacy/lut/library/inputs'
import { JSX, memo, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { IForm } from 'core-components/classes/models/IForm'
import { Table as CoreTable, tableTypes } from 'core-components/library/list'

export type TTableProps<T = IForm, R = string | number> = tableTypes.TTableProps<T, R> & {
  hasTranslate?: boolean
}

export const Table = memo(<P = IForm, R = string | number>(props: TTableProps<P, R>) => {
  const translationMode = useSelector(selectTranslationMode)
  const isTranslationMode = translationMode === TranslationMode.Edit

  const titleRender = useCallback(
    (type: tableTypes.TTitleRenderTypes, text: string, data: object = {}) => {
      if (!props.hasTranslate) {
        return false
      }

      if (type === 'thPopupFilterInput') {
        return (
          <Input
            {...data}
            translation={props.hasTranslate ? 'Value' : undefined}
            label={props.hasTranslate ? undefined : 'Value'}
          />
        )
      }

      if (!text) {
        return false
      }

      if (type === 'rowsCount') {
        return <Translation text={text} span actionsInside />
      } else if (type === 'thEnabled') {
        if (props.hasTranslate && isTranslationMode) {
          return <Translation text={text} span actionsInside />
        }
        return false
      } else if (type === 'thDisabled') {
        return <Translation text={text} span actionsInside />
      } else if (type === 'thPopupEnabled') {
        return <Translation text={text} span actionsInside />
      } else if (type === 'thPopupDisabled' || type === 'columnsFilter') {
        return <Translation text={text} span disabled />
      }

      return <>{text}</>
    },
    [props.hasTranslate, isTranslationMode]
  )
  return <CoreTable {...props} titleRender={titleRender} />
}) as <P = IForm, R = string | number>(props: TTableProps<P, R>) => JSX.Element

export default Table
